import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    chipContent: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.colors.text[600],
        fontWeight: 400,
    },
    chipContentLabel: {
        textTransform: 'capitalize',
        fontWeight: 600,
    },
    chipContentOperator: {
        fontWeight: 400,
        fontSize: 12,
    },
    chipContentValues: {
        fontWeight: 400,
        color: theme.colors.primary.main,
    },
    icon: {
        '&:hover': {
            fill: theme.colors.primary.contrastBlack,
        },
    },
}));
//# sourceMappingURL=ChipContent.styles.js.map